import { Option } from '@urbanx/agx-ui-components';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  AgencyAgentModel,
  EntityGoalsModel,
} from 'Api/Agencies/Types/Agencies';
import { setAndShowErrorToast } from '../../store/config';
import { LoadingState } from '../../utils/loadingState';
import { AppDispatch } from 'store/store';
import { agenciesApi } from 'Api/Agencies/agenciesApi';

export const fetchAgents =
  (authToken: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(startLoadingAgents());
      const { data: agents } =
        await agenciesApi(authToken).get<AgencyAgentModel[]>(
          'GetAgentsInAgency'
        );

      dispatch(agentsLoaded(agents));

      return 'success';
    } catch (err: any) {
      console.error(err);
      dispatch(setAndShowErrorToast(err.message));
      dispatch(errorLoadingAgents());
      return err.message;
    }
  };

export interface ReportingDashboardState {
  loadingState: LoadingState;
  goals: EntityGoalsModel | null;
  goalsLoadingState: LoadingState;
  agents: AgencyAgentModel[];
  agentsLoadingState: LoadingState;
}

const initialState: ReportingDashboardState = {
  loadingState: LoadingState.NotLoaded,
  goals: null,
  goalsLoadingState: LoadingState.NotLoaded,
  agents: [],
  agentsLoadingState: LoadingState.NotLoaded,
};

const slice = createSlice({
  name: 'reportingDashboard',
  initialState,
  reducers: {
    goalsStartedLoading: state => {
      return {
        ...state,
        goals: initialState.goals,
        goalsLoadingState: LoadingState.Loading,
      };
    },
    goalsLoaded: (state, action: PayloadAction<EntityGoalsModel | null>) => {
      const goals = action.payload;
      return {
        ...state,
        goals,
        goalsLoadingState: LoadingState.Loaded,
      };
    },
    startLoadingAgents: (state: ReportingDashboardState) => {
      state.agentsLoadingState = LoadingState.Loading;
    },

    agentsLoaded: (
      state: ReportingDashboardState,
      action: PayloadAction<AgencyAgentModel[]>
    ) => {
      state.agents = action.payload;
      state.agentsLoadingState = LoadingState.Loaded;
    },

    errorLoadingAgents: (state: ReportingDashboardState) => {
      state.agentsLoadingState = LoadingState.Failed;
    },
  },
});

export default slice.reducer;

export const {
  goalsLoaded,
  goalsStartedLoading,
  startLoadingAgents,
  agentsLoaded,
  errorLoadingAgents,
} = slice.actions;

export const PartnershipYearOptions: Option[] = [
  {
    value: 'This Year',
    label: 'This Year',
  },
  {
    value: 'Last Year',
    label: 'Last Year',
  },
];
